import React, { useEffect, useState, useRef } from "react";
import Tables from "../../../Utils/Table/Table1";
import Table from "../../../Utils/Table/Table";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { Clienthistory, getclientINRtradehistory } from "../../../Services/Admin/Addmin";
import { Link, useNavigate } from "react-router-dom";
import { GetUsersName, switchOrderType, getswitchOrderTypedata, INrgetswitchOrderTypedata, ReopenExitTrade, InrReopenExitTrade, DeleteTradeforuser, InrDeleteTradeforuser, ReopenDeleteTrade, INrReopenDeleteTrade, DeleteOrderTradeLogs, INRDeleteOrderTradeLogs } from "../../../Services/Admin/Addmin";
import { ArrowLeftRight, X, LockOpen, Logs, Trash, Trash2, Redo2 } from "lucide-react";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import Swal from "sweetalert2";
import { getAllClient, InrswitchOrderType } from "../../../Services/Superadmin/Superadmin";
import socket from "../../../Utils/socketClient";


const Tradehistory = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const TokenData = getUserFromToken();

  const user_id = TokenData?.user_id;

  const navigate = useNavigate()


  const [data, setData] = useState([]);
  const [userName, setUserName] = useState();
  const [Userid, setUserId] = useState();
  const [search, setSearch] = useState("");
  const [livePrices, setLivePrices] = useState({});
  const [prevPrices, setPrevPrices] = useState({});
  const [statusFilter, setStatusFilter] = useState("all");
  const [logsmodel, setLogsmodel] = useState(false);
  const [deletelogs, setDeleteLogs] = useState(false);
  const [tradeLogs, setTradeLogs] = useState([]);

  const [logsdata, setLogsdata] = useState([])
  const [client, setClient] = useState([]);
  const [activeMarket, setActiveMarket] = useState("USD");
 const decimalPoint = activeMarket === "INR" ? 2 : 3;



  const pricesRef = React.useRef({});
  const prevPricesRef = React.useRef({});

  useEffect(() => {
    const handleForexData = (data) => {
      const symbol = data?.data?.ticker?.toLowerCase();
      const price = Number(data?.data?.Mid_Price);
      if (symbol && !isNaN(price)) {
        const newPrice = price.toFixed(4);
        if (pricesRef.current[symbol] !== newPrice) {
          prevPricesRef.current[symbol] = pricesRef.current[symbol];
          pricesRef.current[symbol] = newPrice;
        }
      }
    };

    const handleAliceTicks = (data) => {
      const token = data?.tk;
      const price = Number(data?.lp);
      if (token && !isNaN(price)) {
        const newPrice = price.toFixed(2);
        if (pricesRef.current[token] !== newPrice) {
          pricesRef.current[token] = newPrice;
        }
      }
    };

    socket.on("receive_data_forex", handleForexData);
    socket.on("alice_ticks", handleAliceTicks);

    const intervalId = setInterval(() => {
      setLivePrices((prev) => {
        let hasChanges = false;
        for (const key in pricesRef.current) {
          if (prev[key] !== pricesRef.current[key]) {
            hasChanges = true;
            break;
          }
        }
        if (hasChanges) {
          setPrevPrices((prevP) => ({ ...prevP, ...prevPricesRef.current }));
          return { ...prev, ...pricesRef.current };
        }
        return prev;
      });
    }, 1000);

    return () => {
      socket.off("receive_data_forex", handleForexData);
      socket.off("alice_ticks", handleAliceTicks);
      clearInterval(intervalId);
    };
  }, []);




  const getallclient = async () => {
    try {
      const data = { userid: user_id };
      const response = await getAllClient(data);
      if (response.status) {
        setClient(response.data);
      }
    } catch (error) { }
  };



  const fetchTradeLogs = async (row) => {
    try {
      const data = { id: row._id, userid: row?.userid };
      let response;
      if (activeMarket === "USD") {
        response = await DeleteOrderTradeLogs(data);

      } else {
        response = await INRDeleteOrderTradeLogs(data);

      }
      if (response.status) {
        setTradeLogs(response.data)
        setDeleteLogs(true)
      }
    } catch (error) {
      console.error('Error fetching trade logs:', error);
    }
  };



  useEffect(() => {
    GetUserName();
    getallclient();
  }, []);

  useEffect(() => {
    getuserallhistory();
  }, [Userid, search, statusFilter, activeMarket, page, rowsPerPage, fromDate, toDate]);



  const logspage = (row) => {
    if (activeMarket === "USD") {
      navigate("/admin/trade-logs", { state: { row } });
    } else {
      navigate("/admin/inr-trade-logs", { state: { row } });

    }

  };


  // const columns1 = [
  //   { Header: "userName", accessor: "userName" },

  //   { Header: "Symbol", accessor: "symbol" },
  //   {
  //     Header: "Entry Price",
  //     accessor: "buy_price",
  //     Cell: ({ cell }) => {
  //       const buy_price = cell.row.buy_price;
  //       const signal_type = cell.row.signal_type;
  //       if (signal_type === "buy_sell") {
  //         return buy_price ? buy_price.toFixed(3) : "-";
  //       } else {
  //         return cell.row.sell_price ? cell.row.sell_price.toFixed(3) : "-";
  //       }
  //     },
  //   },
  //   {
  //     Header: "Exit Price",
  //     accessor: "sell_price",
  //     Cell: ({ cell }) => {
  //       const buy_price = cell.row.buy_price;
  //       const signal_type = cell.row.signal_type;
  //       if (signal_type === "sell_buy") {
  //         return buy_price
  //           ? buy_price.toFixed(3)
  //           : livePrices[cell.row.symbol.toLowerCase()] || "-";
  //       } else {
  //         return cell.row.sell_price
  //           ? cell.row.sell_price.toFixed(3)
  //           : livePrices[cell.row.symbol.toLowerCase()] || "-";
  //       }
  //     },
  //   },
  //   {
  //     Header: "P/L",
  //     accessor: "P/L",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;
  //       const sellPrice = cell.row.sell_price;
  //       const buyPrice = cell.row.buy_price;
  //       const buyQty = cell.row.buy_qty;

  //       if (sellPrice && buyPrice && buyQty) {
  //         const profitLoss = (sellPrice - buyPrice) * buyQty;
  //         const formattedProfitLoss = profitLoss.toFixed(4);

  //         const color = profitLoss > 0 ? "green" : "red";

  //         return (
  //           <span style={{ color }}>
  //             {formattedProfitLoss}
  //           </span>
  //         );
  //       } else if (signal_type === "buy_sell") {
  //         const livePrice = livePrices[cell.row.symbol?.toLowerCase()];
  //         if (livePrice) {
  //           const profitLoss = (livePrice - buyPrice) * cell.row.buy_qty;
  //           const formattedProfitLoss = profitLoss.toFixed(4);
  //           const color = profitLoss > 0 ? "green" : "red";
  //           return <span style={{ color }}>{formattedProfitLoss}</span>;
  //         }
  //       } else if (signal_type === "sell_buy") {
  //         const livePrice = livePrices[cell.row.symbol?.toLowerCase()];
  //         if (livePrice) {
  //           const profitLoss =
  //             (cell.row.sell_price - livePrice) * cell.row.sell_lot;
  //           const formattedProfitLoss = profitLoss.toFixed(4);
  //           const color = profitLoss > 0 ? "green" : "red";
  //           return <span style={{ color }}>{formattedProfitLoss}</span>;
  //         }
  //       }

  //       return "-";
  //     },
  //   },
  //   {
  //     Header: "Entry lot",
  //     accessor: "buy_lot",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;
  //       if (signal_type === "buy_sell") {
  //         return cell.row.buy_lot ? cell.row.buy_lot : "-";
  //       } else {
  //         return cell.row.sell_lot ? cell.row.sell_lot : "-";
  //       }
  //     },
  //   },
  //   {
  //     Header: "Exit lot",
  //     accessor: "sell_lot",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;
  //       if (signal_type === "sell_buy") {
  //         return cell.row.buy_lot ? cell.row.buy_lot : "-";
  //       } else {
  //         return cell.row.sell_lot ? cell.row.sell_lot : "-";
  //       }
  //     },
  //   },

  //   {
  //     Header: "Signal Type",
  //     accessor: "signal_type",
  //     Cell: ({ cell }) => {

  //       const signal_type = cell.row.signal_type;
  //       return (
  //         <>
  //           {signal_type === "buy_sell" ? (
  //             <span style={{ color: "green" }}> BUY</span>
  //           ) : signal_type === "sell_buy" ? (
  //             <span style={{ color: "red" }}> SELL</span>
  //           ) : (
  //             <span style={{ color: "blue" }}> {signal_type}</span>
  //           )}
  //         </>
  //       );
  //     },
  //   },

  //   {
  //     Header: "Entry Time",
  //     accessor: "buy_time",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;

  //       if (signal_type === "buy_sell") {
  //         return cell.row.buy_time ? fDateTimesec(cell.row.buy_time) : "-";
  //       } else {
  //         return cell.row.sell_time ? fDateTimesec(cell.row.sell_time) : "-";
  //       }
  //     },
  //   },
  //   {
  //     Header: "Exit time",
  //     accessor: "sell_time",
  //     Cell: ({ cell }) => {
  //       const signal_type = cell.row.signal_type;

  //       if (signal_type === "sell_buy") {
  //         return cell.row.buy_time ? fDateTimesec(cell.row.buy_time) : "-";
  //       } else {
  //         return cell.row.sell_time ? fDateTimesec(cell.row.sell_time) : "-";
  //       }
  //     },
  //   },

  //   activeMarket === "USD" ? {
  //     Header: "switch",
  //     accessor: "switch",
  //     Cell: ({ cell }) => {
  //       return (
  //         <span onClick={(e) => ChangeTradeType(cell.row)}>
  //           <ArrowLeftRight />
  //         </span>
  //       );
  //     },
  //   } : {
  //     Header: "switch",
  //     accessor: "switch",
  //     Cell: ({ cell }) => {
  //       return (
  //         <span onClick={(e) => INRChangeTradeType(cell.row)}>
  //           <ArrowLeftRight />
  //         </span>
  //       );
  //     },
  //   }, ,
  //   client?.reopentrade == 1 && {
  //     Header: "Reopen Trade",
  //     accessor: "Reopen",
  //     Cell: ({ cell }) => {
  //       const { buy_price, sell_price, signal_type } = cell.row;

  //       // buy/sell price na ho → hide
  //       if (!buy_price || !sell_price) return "--";

  //       // exit time choose based on signal type
  //       const exit_time =
  //         signal_type === "sell_buy"
  //           ? cell.row.buy_time
  //           : cell.row.sell_time;


  //       if (!exit_time) return "--";

  //       // Date check
  //       const exitDateObj = new Date(exit_time);
  //       if (isNaN(exitDateObj.getTime())) return "--";

  //       const exitDate = exitDateObj.toISOString().split("T")[0];
  //       const today = new Date().toISOString().split("T")[0];


  //       if (exitDate !== today) return "--";

  //       return (
  //         <span
  //           style={{ cursor: "pointer", color: "green" }}
  //           onClick={() => ReopenExitTradedata(cell.row)}
  //         >
  //           <LockOpen />
  //         </span>
  //       );
  //     }
  //   },

  //   client?.deleteTrade == 1 && {
  //     Header: "Delete Order",
  //     accessor: "deleteorder",
  //     Cell: ({ cell }) => {
  //       const { buy_price, sell_price, del } = cell.row;

  //       if (!buy_price || !sell_price) {
  //         return "--";
  //       }

  //       if (del == 1) {
  //         return "--"
  //       }

  //       return (
  //         <span style={{ cursor: "pointer", color: "red" }} onClick={(e) => DeleteExitTradedata(cell.row)}>
  //           <Trash2 />
  //         </span>

  //       );
  //     },
  //   },
  //   client?.reopendeletetrade == 1 && {
  //     Header: "Deleted Undo",
  //     accessor: "deleteReopenTrade",
  //     Cell: ({ cell }) => {
  //       const { buy_price, sell_price, del } = cell.row;

  //       if (!buy_price || !sell_price) {
  //         return "--";
  //       }

  //       if (del == 0) {
  //         return "--"
  //       }

  //       return (
  //         <span style={{ cursor: "pointer", color: "green" }} onClick={(e) => ReopenDeleteExitTradedata(cell.row)}>
  //           <Redo2 />
  //         </span>

  //       );
  //     },
  //   },
  //   client?.reopenlogs == 1 && {
  //     Header: "Trade Logs",
  //     accessor: "Logs",
  //     Cell: ({ cell }) => {
  //       return (
  //         <span onClick={(e) => logspage(cell.row)}>
  //           <Logs style={{ color: "red" }} />
  //         </span>
  //       );
  //     },
  //   },
  //   client?.deleteLogs == 1 && {
  //     Header: "Deleted Logs",
  //     accessor: "Logs",
  //     Cell: ({ cell }) => {

  //       return (
  //         <span onClick={(e) => fetchTradeLogs(cell.row)}>
  //           <Logs style={{ color: "blue" }} />
  //         </span>
  //       );
  //     },
  //   }

  // ];




  const columns1 = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ row, index }) => (page - 1) * rowsPerPage + (index + 1),
    },

    { Header: "userName", accessor: "userName" },

    { Header: "Symbol", accessor: "symbol" },

    // ENTRY PRICE
    {
      Header: "Entry Price",
      accessor: "buy_price",
      Cell: ({ row }) => {
        const { buy_price, sell_price, signal_type } = row;

        return signal_type === "buy_sell"
          ? buy_price?.toFixed(decimalPoint) || "-"
          : sell_price?.toFixed(decimalPoint) || "-";
      },
    },

    // EXIT PRICE
    {
      Header: "Exit Price",
      accessor: "sell_price",
      Cell: ({ row }) => {
        const { buy_price, sell_price, signal_type, symbol, token } = row;

        const live = activeMarket === "INR" ? livePrices[token] : livePrices[symbol?.toLowerCase()];
        const livePrice = live || "-";

        const format = (value) =>
          value !== null && value !== undefined ? Number(value).toFixed(decimalPoint) : livePrice;

        if (signal_type === "sell_buy") {
          return format(buy_price);
        } else {
          return format(sell_price);
        }
      },
    }
    ,

    // P/L
    {
      Header: "P/L",
      accessor: "P/L",
      Cell: ({ row }) => {
        const { signal_type, sell_price, buy_price, buy_qty, sell_lot, symbol, token } = row;

        // EXITED TRADE
        if (sell_price && buy_price && buy_qty) {
          const pl = (sell_price - buy_price) * buy_qty;
          return (
            <span style={{ color: pl > 0 ? "green" : "red" }}>
              {pl.toFixed(2)}
            </span>
          );
        }

        // LIVE TRADE
        const live = activeMarket === "INR" ? livePrices[token] : livePrices[symbol?.toLowerCase()];
        if (!live) return "-";

        // BUY -> SELL
        if (signal_type === "buy_sell") {
          const pl = (live - buy_price) * buy_qty;
          return (
            <span style={{ color: pl > 0 ? "green" : "red" }}>
              {pl.toFixed(decimalPoint)}
            </span>
          );
        }

        // SELL -> BUY
        if (signal_type === "sell_buy") {
          const pl = (sell_price - live) * sell_lot;
          return (
            <span style={{ color: pl > 0 ? "green" : "red" }}>
              {pl.toFixed(decimalPoint)}
            </span>
          );
        }

        return "-";
      },
    },

    // ENTRY LOT
    {
      Header: "Entry lot / Qty",
      accessor: "buy_lot",
      Cell: ({ row }) =>
        row.signal_type === "buy_sell"
          ? row.buy_lot || "-"
          : row.sell_lot || "-",
    },

    // EXIT LOT
    {
      Header: "Exit lot  / Qty",
      accessor: "sell_lot",
      Cell: ({ row }) =>
        row.signal_type === "sell_buy"
          ? row.buy_lot || "-"
          : row.sell_lot || "-",
    },

    // SIGNAL TYPE
    {
      Header: "Signal Type",
      accessor: "signal_type",
      Cell: ({ row }) => {
        const type = row.signal_type;
        return type === "buy_sell" ? (
          <span style={{ color: "green" }}>BUY</span>
        ) : type === "sell_buy" ? (
          <span style={{ color: "red" }}>SELL</span>
        ) : (
          <span style={{ color: "blue" }}>{type}</span>
        );
      },
    },

    // ENTRY TIME
    {
      Header: "Entry Time",
      accessor: "buy_time",
      Cell: ({ row }) =>
        row.signal_type === "buy_sell"
          ? row.buy_time
            ? fDateTimesec(row.buy_time)
            : "-"
          : row.sell_time
            ? fDateTimesec(row.sell_time)
            : "-",
    },

    // EXIT TIME
    {
      Header: "Exit time",
      accessor: "sell_time",
      Cell: ({ row }) =>
        row.signal_type === "sell_buy"
          ? row.buy_time
            ? fDateTimesec(row.buy_time)
            : "-"
          : row.sell_time
            ? fDateTimesec(row.sell_time)
            : "-",
    },

    // SWITCH BUTTON
    activeMarket === "USD"
      ? {
        Header: "Switch",
        accessor: "switch",
        Cell: ({ row }) => (
          <span onClick={() => ChangeTradeType(row)}>
            <ArrowLeftRight />
          </span>
        ),
      }
      : {
        Header: "Switch",
        accessor: "switch",
        Cell: ({ row }) => (
          <span onClick={() => INRChangeTradeType(row)}>
            <ArrowLeftRight />
          </span>
        ),
      },

    // client?.reopentrade == 1 && {
    //   Header: "Reopen Trade",
    //   accessor: "Reopen",
    //   Cell: ({ row }) => {
    //     const { buy_price, sell_price, signal_type } = row;

    //     if (!buy_price || !sell_price) return "--";

    //     const exitTime =
    //       signal_type === "sell_buy" ? row.buy_time : row.sell_time;

    //     if (!exitTime) return "--";

    //     const exitDate = new Date(exitTime).toISOString().split("T")[0];
    //     const today = new Date().toISOString().split("T")[0];

    //     if (exitDate !== today) return "--";

    //     return (
    //       <span
    //         style={{ cursor: "pointer", color: "green" }}
    //         onClick={() => ReopenExitTradedata(row)}
    //       >
    //         <LockOpen />
    //       </span>
    //     );
    //   },
    // },

    // client?.deleteTrade == 1 && {
    //   Header: "Delete Order",
    //   accessor: "deleteorder",
    //   Cell: ({ row }) => {
    //     if (!row.buy_price || !row.sell_price) return "--";
    //     if (row.del == 1) return "--";

    //     return (
    //       <span
    //         style={{ cursor: "pointer", color: "red" }}
    //         onClick={() => DeleteExitTradedata(row)}
    //       >
    //         <Trash2 />
    //       </span>
    //     );
    //   },
    // },

    // client?.reopendeletetrade == 1 && {
    //   Header: "Deleted Undo",
    //   accessor: "deleteReopenTrade",
    //   Cell: ({ row }) =>
    //     row.del == 1 ? (
    //       <span
    //         style={{ cursor: "pointer", color: "green" }}
    //         onClick={() => ReopenDeleteExitTradedata(row)}
    //       >
    //         <Redo2 />
    //       </span>
    //     ) : (
    //       "--"
    //     ),
    // },

    // TRADE LOGS
    client?.reopenlogs == 1 && {
      Header: "Trade Logs",
      accessor: "Logs",
      Cell: ({ row }) => (
        <span onClick={() => logspage(row)}>
          <Logs style={{ color: "red" }} />
        </span>
      ),
    },

    // DELETED LOGS
    client?.deleteLogs == 1 && {
      Header: "Deleted Logs",
      accessor: "Logs",
      Cell: ({ row }) => (
        <span onClick={() => fetchTradeLogs(row)}>
          <Logs style={{ color: "blue" }} />
        </span>
      ),
    },
  ];


  const columns = [
    { Header: "AdminName", accessor: "Superadmin" },
    { Header: "UserName", accessor: "UserName" },
    { Header: "Symbol", accessor: "Symbol" },
    {
      Header: "Type",
      accessor: "type",
      Cell: ({ cell }) => {
        return cell.row.type === "sell_buy" ? "buy_sell" : "sell_buy"
      }

    },
    {
      Header: "Message", accessor: "message",
      Cell: ({ cell }) => {
        return cell.row.message === "Order type switched to sell_buy" ? "Order type switched BUY to SELL" : "Order type switched SELL to BUY"
      }
    },
    {
      Header: "UpdatedAt",
      accessor: "updatedAt",
      Cell: ({ cell }) => {
        return fDateTimesec(cell.value);
      },
    },
  ];



  const columns2 = [
    { Header: "Type", accessor: "action_type" },
    { Header: "Buy Price", accessor: "buy_price" },
    { Header: "Sell Price", accessor: "sell_price" },
    {
      Header: "PNL",
      accessor: "pnl",
      Cell: ({ cell }) => {
        return cell?.row?.pnl?.toFixed(2)
      },
      sortable: true,
    },
    {
      Header: "Margin Used", accessor: "margin_used",
      Cell: ({ cell }) => {
        return cell?.row?.margin_used?.toFixed(2)
      }
    },
    { Header: "Brokerage Applied", accessor: "brokerage_applied" },
    {
      Header: "Balance Before", accessor: "balance_before",
      Cell: ({ cell }) => {
        return cell?.row?.balance_before?.toFixed(2)
      }
    },
    {
      Header: "Balance After", accessor: "balance_after",
      Cell: ({ cell }) => {
        return cell?.row?.balance_after?.toFixed(2)
      }
    },
    {
      Header: "requiredFund", accessor: "requiredFund",
      Cell: ({ cell }) => {
        return cell?.row?.requiredFund?.toFixed(2)
      }
    },
    {
      Header: "Entry Type", accessor: "signal_type",
      Cell: ({ cell }) => {
        return cell.row.type === "sell_buy" ? "SELL" : "BUY"
      }

    },
    {
      Header: "UpdatedAt",
      accessor: "timestamp",
      Cell: ({ cell }) => {
        return fDateTimesec(cell?.value);
      },
    },
  ];




  // Function to get user history
  const getuserallhistory = async () => {
    try {
      const data = {
        userid: Userid,
        adminid: user_id,
        toDate: toDate,
        fromDate: fromDate,
        search,
        status: statusFilter,
        page,
        limit: rowsPerPage
      };

      let response;
      if (activeMarket === "INR") {
        response = await getclientINRtradehistory(data);
      } else {
        response = await Clienthistory(data);
      }
      setData(response.data || []);
      setTotalPages(response?.pagination?.totalPages || 1);
    } catch (error) {
      console.error(error);
    }
  };





  const GetUserName = async () => {
    try {
      const admin_id = user_id;
      const response = await GetUsersName({ admin_id });
      if (response.status) {
        setUserName(response.data);
      } else {
        setUserName([])
      }
    } catch (error) { }
  };




  const ReopenExitTradedata = async (row) => {
    try {

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to reopen this trade?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, reopen it!',
        cancelButtonText: 'No, cancel'
      });

      if (result.isConfirmed) {
        const data = { userid: row.userid, id: row._id };
        let response;
        if (activeMarket === "USD") {
          response = await ReopenExitTrade(data);

        } else {
          response = await InrReopenExitTrade(data);

        }

        if (response.status) {
          Swal.fire(
            'Reopened!',
            'The trade has been reopened successfully.',
            'success'
          );
          getuserallhistory()
        } else {
          Swal.fire(
            'Error!',
            response.message || 'Something went wrong!',
            'error'
          );
        }
      } else {
        Swal.fire(
          'Cancelled',
          'The trade is safe',
          'info'
        );
      }
    } catch (error) {
      console.error(error);
      Swal.fire(
        'Error!',
        'Something went wrong while reopening trade.',
        'error'
      );
    }
  };



  const DeleteExitTradedata = async (row) => {
    try {

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to delete this trade?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel'
      });

      if (result.isConfirmed) {
        const data = { userid: row.userid, id: row._id };
        let response;
        if (activeMarket === "USD") {
          response = await DeleteTradeforuser(data);

        } else {
          response = await InrDeleteTradeforuser(data);

        }
        if (response.status) {
          Swal.fire(
            'Deleted!',
            'The trade has been Deleted successfully.',
            'success'
          );
          getuserallhistory()
        } else {
          Swal.fire(
            'Error!',
            response.message || 'Something went wrong!',
            'error'
          );
        }
      } else {
        Swal.fire(
          'Cancelled',
          'The trade is safe',
          'info'
        );
      }
    } catch (error) {
      console.error(error);
      Swal.fire(
        'Error!',
        'Something went wrong while Delete trade.',
        'error'
      );
    }
  };



  const ReopenDeleteExitTradedata = async (row) => {
    try {

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to Reopen this trade?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel'
      });

      if (result.isConfirmed) {
        const data = { userid: row.userid, id: row._id };
        let response;
        if (activeMarket === "USD") {
          response = await ReopenDeleteTrade(data);

        } else {
          response = await INrReopenDeleteTrade(data);

        }

        if (response.status) {
          Swal.fire(
            'Reopened!',
            'The trade has been Reopen deleted trade successfully.',
            'success'
          );
          getuserallhistory()
        } else {
          Swal.fire(
            'Error!',
            response.message || 'Something went wrong!',
            'error'
          );
        }
      } else {
        Swal.fire(
          'Cancelled',
          'The trade is safe',
          'info'
        );
      }
    } catch (error) {
      Swal.fire(
        'Error!',
        'Something went wrong while reopen Delete trade.',
        'error'
      );
    }
  };





  const calculateTotalProfitLoss = () => {
    return data
      .reduce((total, row) => {
        const sellPrice = row.sell_price;
        const buyPrice = row.buy_price;
        const buyQty = row.buy_qty;
        const signal_type = row.signal_type;
        if (sellPrice && buyPrice && buyQty) {
          return total + (sellPrice - buyPrice) * buyQty;
        }
        return total;
      }, 0)
      .toFixed(4);
  };



  const totalProfitLoss = calculateTotalProfitLoss();

  const ChangeTradeType = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to change trade type?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = { id: row._id, adminid: TokenData.user_id };
        const response = await switchOrderType(data);

        if (response.status) {
          Swal.fire("Success!", "Trade type changed successfully.", "success");
          getuserallhistory();
        } else {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };



  const INRChangeTradeType = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to change trade type?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = { id: row._id, adminid: TokenData.user_id };
        const response = await InrswitchOrderType(data);

        if (response.status) {
          Swal.fire("Success!", "Trade type changed successfully.", "success");
          getuserallhistory();
        } else {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };




  const fetchChangeTradeType = async (row) => {
    const data = { admin_id: user_id };
    const response = await getswitchOrderTypedata(data);
    if (response.status) {
      setLogsdata(response.data)
      getuserallhistory();
    } else {
      alert("Error");
    }
  };



  const InrfetchChangeTradeType = async (row) => {
    const data = { admin_id: user_id };
    const response = await INrgetswitchOrderTypedata(data);
    if (response.status) {
      setLogsdata(response.data)
      getuserallhistory();
    } else {
      alert("Error");
    }
  };





  useEffect(() => {
    if (logsmodel) {
      if (activeMarket == "USD") {
        fetchChangeTradeType()
      } else {
        InrfetchChangeTradeType()
      }
    }
  }, [logsmodel])


  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
  };

  function handleRefresh() {
    setSearch("");
    setUserId("");
    setStatusFilter("all");
    setFromDate("");
    setToDate("");
    setPage(1);


  }


  return (
    <>
      <div>
        <div className="container-fluid mt-5 ">
          <div className="row">
            <div className="col-lg-12">
              <div className="card transaction-table custom-bg">
                <div className="card-header border-0 flex-wrap ">
                  <div className="mb-4">
                    <h4 className="card-title mb-0 py-2">📊 Trade History</h4>

                  </div>

                  <div className="wallet-tabs ">
                    <div className="btn-group" role="group">
                      {TokenData?.market.includes(0) && (
                        <button
                          type="button"
                          className={`btn ${activeMarket === "USD"
                            ? "btn-primary"
                            : "btn-outline-primary"
                            }`}
                          onClick={() => setActiveMarket("USD")}
                        >
                          <i className="fas fa-dollar-sign me-2"></i>
                          USD Wallet
                        </button>
                      )}

                      {TokenData?.market.includes(1) && (
                        <button
                          type="button"
                          className={`btn ${activeMarket === "INR"
                            ? "btn-primary"
                            : "btn-outline-primary"
                            }`}
                          onClick={() => setActiveMarket("INR")}
                        >
                          <i className="fas fa-rupee-sign me-2"></i>
                          INR Wallet
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <div className="tab-content" id="myTabContent1">
                    <div
                      className="tab-pane fade show active"
                      id="Week"
                      role="tabpanel"
                      aria-labelledby="Week-tab"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "1rem",
                          gap: "20px",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* 🔍 Search */}
                        <div style={{ flex: 1, minWidth: "220px" }}>
                          <label style={{ fontWeight: "bold" }}>🔍 Search:</label>
                          <input
                            type="text"
                            placeholder="Search..."
                            className="form-control mt-1"
                            style={{
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#f8f9fa",
                            }}
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value)
                              setPage(1)
                            }}
                          />
                        </div>

                        {/* 👤 Users */}
                        <div style={{ flex: 1, minWidth: "220px" }}>
                          <label style={{ fontWeight: "bold" }}>👤 Users:</label>
                          <select
                            className="form-select mt-1"
                            style={{
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#f8f9fa",
                            }}
                            onChange={(e) => setUserId(e.target.value)}
                            defaultValue=""
                          >
                            <option value="all">Select a user</option>
                            {userName?.map((username) => (
                              <option key={username._id} value={username._id}>
                                {username.UserName}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* 📊 Status */}
                        <div style={{ flex: 1, minWidth: "220px" }}>
                          <label style={{ fontWeight: "bold" }}>📊 Status:</label>
                          <select
                            className="form-select mt-1"
                            style={{
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#f8f9fa",
                            }}
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                          >
                            <option value="">All</option>
                            <option value="open">Open</option>
                            <option value="close">Close</option>
                          </select>
                        </div>

                        <div className="col-md-3 mt-1">
                          <label className="fw-bold">📅 From Date</label>
                          <input
                            style={{
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#f8f9fa",
                            }}
                            type="date"
                            className="form-control"
                            onChange={(e) => setFromDate(e.target.value)}
                            value={fromDate}
                          />
                        </div>

                        {/* To Date */}
                        <div className="col-md-2 ">
                          <label className="fw-bold mb-1">📅 To Date</label>
                          <input
                            style={{
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#f8f9fa",
                            }}
                            type="date"
                            className="form-control"
                            onChange={(e) => setToDate(e.target.value)}
                            value={toDate}
                          />
                        </div>

                        <div className="mt-4">
                          <button
                            className="refresh-btn"
                            onClick={() => handleRefresh()}
                          >
                            <i className="bi bi-arrow-repeat"></i>
                            Refresh
                          </button>
                        </div>



                        {/* 💰 Total + Logs Button */}
                        <div
                          style={{
                            flex: 1,
                            minWidth: "220px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "10px",
                          }}
                        >
                          <h5 className="m-0">
                            Total Profit/Loss:{" "}
                            <span
                              style={{
                                color: totalProfitLoss > 0 ? "green" : "red",
                                fontSize: "1.2rem",
                              }}
                            >
                              {(Number(totalProfitLoss) || 0).toFixed(2)}
                            </span>
                          </h5>

                          <button
                            onClick={() => setLogsmodel(true)}
                            className="btn btn-primary"
                            style={{ height: "40px" }}
                          >
                            Logs
                          </button>
                        </div>
                      </div>


                      <Tables
                        columns={columns1}
                        data={data}
                        page={page}
                        totalPages={totalPages}
                        initialRowsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div >


      {logsmodel && (
        <div
          className="modal show d-block"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content shadow-lg rounded-3">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title text-white">📋 System Logs</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setLogsmodel(false)}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <X size={20} />
                </button>
              </div>
              <Table columns={columns} data={logsdata} search={search} />
            </div>
          </div>
        </div>
      )}


      {
        deletelogs && (
          <div
            className="modal show d-block"
            style={{
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1050,
            }}
          >
            <div className="modal-dialog modal-xl modal-dialog-centered">
              <div className="modal-content shadow-lg rounded-3">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title text-white">📋 Logs</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setDeleteLogs(false)}
                    style={{
                      background: "transparent",
                      border: "none",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <X size={20} />
                  </button>
                </div>
                <Table columns={columns2} data={tradeLogs} search={search} />
              </div>
            </div>
          </div>
        )
      }



    </>
  );
};

export default Tradehistory;